export type CompanyProfileModalDetailsAdditionalProps = {
  companyLogoError?: string;
  companyLogoPreviewUrl?: string;
  isCompanyLogoDeleteRequested?: boolean;
  onCompanyLogoFileSelect?: (file: File | undefined) => void;
  onCompanyLogoRemove?: () => void;
  onCompanyLogoRestore?: () => void;
  showCompanyLogo?: boolean;
};

export const companyProfileModalDetailsAdditionalDefaultProps: CompanyProfileModalDetailsAdditionalProps = {
  companyLogoError: undefined,
  companyLogoPreviewUrl: undefined,
  isCompanyLogoDeleteRequested: false,
  showCompanyLogo: true,
};
